import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as types from "../constants/user-types";

// const initialState = {
//   loading: false,
// };

const userReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case types.USER_LOGIN_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.USER_LOGIN_SUCCESS:
      return { ...state, loading: false, userInfo: action.payload, error: "" };
    case types.USER_LOGIN_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.USER_REGISTER_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.USER_REGISTER_SUCCESS:
      return { ...state, loading: false, userInfo: action.payload, error: "" };
    case types.USER_REGISTER_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.PASSWORD_RESET_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PASSWORD_RESET_SUCCESS:
      return { ...state, loading: false, error: "" };
    case types.PASSWORD_RESET_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.USER_DETAILS_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.USER_DETAILS_SUCCESS:
      return { ...state, loading: false, userData: action.payload, error: "" };
    case types.USER_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.USER_DETAILS_RESET:
      return { ...state, user: {}, error: "" };
    case types.USER_UPDATE_PROFILE_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.USER_UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        userData: action.payload,
        error: "",
      };
    case types.USER_UPDATE_PROFILE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.USER_UPDATE_PROFILE_RESET:
      return { error: "" };

    case types.USER_LOGOUT:
      return { loading: false, error: "" };
    default:
      return state;
  }
};

const persistConfig = {
  keyPrefix: "svc-",
  key: "user",
  storage,
};

export default persistReducer(persistConfig, userReducer);
// export default userReducer;
